import { render } from "./SchedaSuora.vue?vue&type=template&id=1bf137ee"
import script from "./SchedaSuora.vue?vue&type=script&lang=js"
export * from "./SchedaSuora.vue?vue&type=script&lang=js"

import "./SchedaSuora.vue?vue&type=style&index=0&id=1bf137ee&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__